import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function OrderCancelDialog({ order, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [refund, setRefund] = useState(true);
  const [busy, setBusy] = useState(false);
  const canRefund = order.payment_status === "paid" && order.paypal_capture_id;

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/orders/${order.session_id}/cancel`, { reason, refund: canRefund ? refund : false });
      toast.success(data.message);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Annulation impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="order-cancel-dialog" className="bg-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-bark">Annuler la commande n° {order.session_id.slice(-8).toUpperCase()}</DialogTitle>
          <DialogDescription>Elle passera dans l'historique des annulations. Le stock et les points sont remis, et le chiffre d'affaires est recalculé.</DialogDescription>
        </DialogHeader>
        <label className="block text-sm font-medium text-bark">Motif (facultatif)
          <input data-testid="order-cancel-reason" value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} className="mt-1 w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-2.5 text-sm outline-none focus:border-amber-deep" />
        </label>
        {canRefund && (
          <label className="flex items-center gap-2 text-sm text-bark">
            <input data-testid="order-cancel-refund" type="checkbox" checked={refund} onChange={(e) => setRefund(e.target.checked)} className="h-4 w-4 accent-amber-deep" /> Rembourser le client via PayPal
          </label>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" data-testid="order-cancel-close" onClick={onClose} className="rounded-full border border-amber-900/20 px-5 py-2 text-sm text-bark hover:border-amber-deep">Retour</button>
          <button type="button" data-testid="order-cancel-confirm" disabled={busy} onClick={submit} className="flex items-center gap-2 rounded-full bg-terra px-5 py-2 text-sm font-semibold text-white hover:bg-terra/85 disabled:opacity-60">
            {busy && <Loader2 size={14} className="animate-spin" />} Annuler la commande
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
